import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import api from "../lib/api";

/**
 * Small streak indicator for the header. Polls on mount + every 5 minutes.
 * Renders nothing while loading or when streak < 2 (no celebration of day 1).
 */
export default function StreakFlame() {
  const [snap, setSnap] = useState(null);

  useEffect(() => {
    let mounted = true;
    const tick = () => api.get("/me/streak").then(({ data }) => mounted && setSnap(data)).catch(() => {});
    tick();
    const id = setInterval(tick, 5 * 60 * 1000);
    return () => { mounted = false; clearInterval(id); };
  }, []);

  if (!snap || snap.streak_days < 2) return null;

  const frozen = snap.frozen;
  const tone = frozen ? "text-sky-500" : "text-orange-500";
  const bg = frozen ? "bg-sky-50 border-sky-200" : "bg-orange-50 border-orange-200";
  const label = frozen ? "Used your one-day grace" : "Daily login streak";
  return (
    <span
      data-testid="streak-flame"
      title={`${label}: ${snap.streak_days} days`}
      className={`inline-flex items-center gap-1 px-2.5 h-8 rounded-full border ${bg} ${tone} font-extrabold text-sm`}
    >
      {frozen ? "🧊" : <Flame size={14} className="inline-block" />}
      <span>{snap.streak_days}</span>
    </span>
  );
}
